var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5027 17.7879L14.3573 13.3632C15.4915 11.9334 16.0571 10.0995 15.9364 8.24304C15.8158 6.38655 15.0181 4.65039 13.7093 3.39572C12.4005 2.14105 10.6815 1.46448 8.90975 1.50675C7.13801 1.54902 5.45 2.30688 4.19687 3.62267C2.94374 4.93846 2.22197 6.71087 2.18171 8.5712C2.14145 10.4315 2.78581 12.2365 3.98073 13.6107C5.17565 14.9849 6.82914 15.8225 8.59722 15.9492C10.3653 16.0759 12.1119 15.4821 13.4735 14.2911L17.6189 18.7159L18.5027 17.7879ZM3.45228 8.7471C3.45228 7.57895 3.78218 6.43704 4.40027 5.46576C5.01835 4.49449 5.89685 3.73747 6.92469 3.29044C7.95252 2.84341 9.08352 2.72644 10.1747 2.95434C11.2658 3.18223 12.2681 3.74475 13.0548 4.57075C13.8414 5.39675 14.3772 6.44915 14.5942 7.59485C14.8112 8.74055 14.6998 9.9281 14.2741 11.0073C13.8484 12.0865 13.1274 13.009 12.2024 13.658C11.2773 14.307 10.1898 14.6534 9.07728 14.6534C7.58595 14.6516 6.15617 14.0288 5.10163 12.9215C4.0471 11.8143 3.45394 10.313 3.45228 8.7471Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSearch);
export default __webpack_public_path__ + "static/media/carbon_search.3a14a7ac02dbdf30ad1828a6c39304af.svg";
export { ForwardRef as ReactComponent };